import {
  HttpClient,
  HttpEvent,
  HttpEventType,
  HttpHeaders,
  HttpParams,
} from "@angular/common/http";
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  NgbModal,
  NgbModalConfig,
  NgbModalRef,
  NgbOffcanvas,
} from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
// import moment from "moment";
import { DOCUMENT } from "@angular/common";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators
} from "@angular/forms";
import {
  EventApi,
  EventClickArg
} from "@fullcalendar/angular";
import { DataTableDirective } from "angular-datatables";
import * as _ from "lodash";
import moment from "moment";
import { CookieService } from "ngx-cookie-service";
import { Subject, Subscription, forkJoin } from "rxjs";
import { breadcrumbItem } from "src/app/components/breadcrumbs/breadcrumbs.model";
import { AlertService } from "src/app/core/services/AlertService/alert.service";
import { AppAliasService } from "src/app/core/services/app-alias.service";
import { AuthenticationService } from "src/app/core/services/auth.service";
import { EmployeeListService } from "src/app/core/services/employees/employee-list.service";
import { JobTypeService } from "src/app/core/services/employees/job-type/job-type.service";
import { locationBroadcastService } from "src/app/core/services/loaction-broadcast.service";
import { LocationsService } from "src/app/core/services/locations/locations.service";
import { PermissionService } from "src/app/core/services/permission.service";
import { BreadcrumbService } from "src/app/services/breadcrumb";
import { AppState } from "src/app/store/app.state";
import { setLoadingSpinner } from "src/app/store/sharedstate/shared.actions";
// import { ApiService } from "./../../../services/api";
// import { TimezoneService } from "./../../../services/timezone";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import SimpleUploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter';
// import { SimpleUploadAdapter } from 'ckeditor5';
// import Base64UploadAdapter from "@ckeditor/ckeditor5-upload/src/adapters/base64uploadadapter";
import { BlurEvent, ChangeEvent, FocusEvent } from "@ckeditor/ckeditor5-angular";
import { TranslatePipe } from "src/app/core/pipes/translate.pipe";
import Adapter from "src/app/core/services/ckeditorAdapter";
import { ApiService } from "src/app/services/api";
import { TimezoneService } from "src/app/services/timezone";
import { SupportPinService } from "src/app/core/services/support-pin/support-pin.service";

@Component({
  selector: 'app-refer-statics',
  templateUrl: './refer-statics.component.html',
  styleUrls: ['./refer-statics.component.scss'],
  providers: [TranslatePipe],

})
export class ReferStaticsComponent implements OnInit {

  @ViewChild("reset2faContent") reset2faContent;

  private dataSubscription: Subscription = null;

  private Timezone: any = this.timezoneService.get()

  // Load the CKEditor
  public Editor = ClassicEditor;
  public editorContent: string = ''; // CKEditor content
  // ckconfig;
  public componentEvents: string[] = [];
  editorConfig = {
    placeholder: 'Please Describe the Issue...',
    toolbar: ['heading', '|', 'bold', 'italic', 'link', '|', 'bulletedList', 'numberedList', '|', 'imageUpload', 'blockQuote', '|', 'undo', 'redo', '|', 'mediaEmbed', '|', 'insertTable', '|', 'delete'],
    isReadOnly: true
  };

  breadcrumbItems: breadcrumbItem[] = [
    {
      label: "Home",
      active: false,
      url: "/home",
    },
    {
      label: "Referral Statistic",
      active: true,
      url: "",
    },
  ];

  active = 1;

  isEmpty: boolean = false;
  isSearch: boolean = false;
  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;
  dtOptions: DataTables.Settings = { paging: true };
  dtTrigger: Subject<any> = new Subject();

  merchantId = this.cookieService.get("merchantId");
  currency: any = this.cookieService.get("currency");
  searchName: any;

  status: any;
  totalHours: any;
  page = 1;
  count = 0;
  tableSize = 10;
  reports: any = [];
  startTodayTime: any;
  endOfWeekTime: any;
  timeFormatRegex = "^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$";
  isValidTimeShift: any = true;
  isValidTimeShiftHours: any = true;
  isValidTimeAssignedSection: any = true;
  isValidTimeAssignedTab: any = true;
  isValidTimeStartTime: any = true;
  isValidTimeEndTime: any = true;
  value: string;
  storeId: any = this.cookieService.get("storeId");
  params: any = new HttpParams();
  timeAndHourDuration: any;
  httpOptions = {};
  httpOptions2 = {};
  headerToken = {
    "Content-Type": "application/json",
    Authorization: this.cookieService.get("token"),
  };
  GLOBALURL: string;
  totalCount: number;
  totalComplate: number;
  totalPending: number;
  canAccess: boolean = true;



  userData = this.authService.getUserFromLocalStorage();
  selectedEmployee: any;
  hourForm: FormGroup;
  requestTimeOffForm: FormGroup;
  addShiftForm: FormGroup;
  referralForm: FormGroup;

  hours = [];
  isLoading = false;
  isLessThanEndTime = true;
  issueDescription = "";

  locations$: any = [];

  isLoadingUploadeEmployee = false;

  showUploadEmployeeProgress = false;
  isUploadEmployeeDone = false;

  employeeFiles: File[] = [];
  progress = 0;



  newEventDate: any;
  schedule = [];
  scheduleModalRef: NgbModalRef;
  requestTimeOffModalRef: NgbModalRef;
  addShiftModalRef: NgbModalRef;

  recurring = false;
  nextDay = false;

  startTime = "00:00";
  endTime = "00:00";

  //location service check if load data
  isLoadData = false;
  settings: any;
  formattedTotalHours: string;
  timeError: boolean = false;
  supportPin: any;
  displayPin: any;
  currantEmployee: any;
  startDate: any = this.timezoneService.get()().startOf("day");
  endDate: any = this.timezoneService.get()().endOf("day");
  startDateDisplay: any = this.startDate.unix();
  endDateDisplay: any = this.endDate.unix();
  startDateDisplayFormatted: any = this.timezoneService.get()
    .unix(this.startDateDisplay)
    .format("MMM Do YYYY");
  endDateDisplayFormatted: any = this.timezoneService.get()
    .unix(this.endDateDisplay)
    .format("MMM Do YYYY");
  options: any = {
    locale: { format: "YYYY-MM-DD" },
    startDate: this.timezoneService.get()().startOf("day"),
    endDate: this.timezoneService.get()().endOf("day"),
    alwaysShowCalendars: true,
    ranges: {
      Today: [this.timezoneService.get()(), this.timezoneService.get()()],
      Yesterday: [this.timezoneService.get()().subtract(1, "days"), this.timezoneService.get()().subtract(1, "days")],
      "Last 7 Days": [this.timezoneService.get()().subtract(6, "days"), this.timezoneService.get()()],
      "Last 30 Days": [this.timezoneService.get()().subtract(29, "days"), this.timezoneService.get()()],
      "This Month": [this.timezoneService.get()().startOf("month"), this.timezoneService.get()().endOf("month")],
      "Last Month": [
        this.timezoneService.get()().subtract(1, "month").startOf("month"),
        this.timezoneService.get()().subtract(1, "month").endOf("month"),
      ],
    },
  };
  employeeId: any;

  constructor(
    @Inject(DOCUMENT) private document: any,
    config: NgbModalConfig,
    private translatePipe: TranslatePipe,
    public modalService: NgbModal,
    private fb: FormBuilder,
    private employeeListService: EmployeeListService,
    private jobTypeService: JobTypeService,
    private authService: AuthenticationService,
    private toastr: AlertService,
    private store: Store<AppState>,
    private router: Router,
    public route: ActivatedRoute,
    private cookieService: CookieService,
    private modalConfig: NgbModalConfig,
    public http: HttpClient,
    private ApiService: ApiService,
    private BreadcrumbService: BreadcrumbService,
    private timezoneService: TimezoneService,
    private renderer: Renderer2,
    public permissionService: PermissionService,
    private el: ElementRef,
    private cdr: ChangeDetectorRef,
    private AppAliasService: AppAliasService,
    public offcanvasService: NgbOffcanvas,
    private toastrservice: AlertService,
    private supportPinService: SupportPinService,
  ) {

    this.GLOBALURL = this.ApiService.getBaseURL();
    this.employeeListService.GLOBALURL = this.ApiService.getBaseURL();
    this.params = new HttpParams();

    this.dtOptions = {
      pageLength: 10,
      language: {
        emptyTable: "No Tickets Available in Table",
        searchPlaceholder: "Search Tickets",
        search: "",
      },
      // scrollY: 'calc(100vh - 510px)',
      // scrollCollapse: true,
      scrollX: true,
      ordering: false,
      // dom: '<"top"f>t<"bottom"lip>',
      dom: '<"top" f><"table-params" t><"bottom" lip>',
      paging: true,
      //columnDefs: [{ targets: 3, orderable: false }],
      pagingType: "simple_numbers",
      serverSide: true,
      processing: false,

      ajax: (dataTablesParameters: any, callback) => {
        //objectToHttpParams added outside ngonit
        const params: any = this.objectToHttpParams(dataTablesParameters);
        this.storeId = this.cookieService.get("storeId");
        this.params = new HttpParams();

        const search = JSON.parse(
          params.updates.find((obj) => {
            return obj.param === "search";
          }).value
        ).value;

        // find out offset
        const offset = params.updates.find((obj) => {
          return obj.param === "start";
        }).value;

        // find out limit
        const limit = params.updates.find((obj) => {
          return obj.param === "length";
        }).value;

        this.value = this.cookieService.get("token");

        // this.params = this.params.set("startDate", this.startDateDisplay);
        // this.params = this.params.set("endDate", this.endDateDisplay);
        // this.params = this.params.set("status", 1);

        // set params as per search key value
        // this.params = this.params.set("limit", limit);
        // this.params = this.params.set("offset", offset);
        if (search !== "") {
          this.params = this.params.set("search", search);
          this.isSearch = true;
        }
        this.employeeId = this.cookieService.get("employeeId");
        // this.params = this.params.set("merchantId", this.merchantId);
        // this.params = this.params.set("storeId", this.storeId);
        this.params = this.params.set("employeeId", this.employeeId);

        this.httpOptions = { headers: new HttpHeaders(this.headerToken) };

        this.dataSubscription = this.http
          .get(this.GLOBALURL + "/merchant/referralEarning", {
            headers: new HttpHeaders(this.headerToken),
            params: this.params,
          })
          .subscribe(
            (response: any) => {
              this.totalComplate = response.summary.totalReferrals,
                this.totalCount = response.summary.totalEarnings,
                this.totalPending = response.summary.pendingEarnings,
                this.store.dispatch(setLoadingSpinner({ status: false }));
              // response.total = response?.response?.length || 0
              if (response.total <= 0 && this.isSearch === false)
                this.isEmpty = true;
              else this.isEmpty = false;
              callback({
                recordsTotal: response.total,
                recordsFiltered: response.total,
                data: [],
                // add one more key to store the response data
                response: response.response,
              });
              this.employees = [];
              response?.response?.forEach((element, index) => {
                let character = "";
                character = element?.employeeFirstName?.trim();
                var a = character?.split(" ");
                // character = a[0]?.charAt(0)?.toUpperCase();
                // element.char = character;
                element.index = index;
                this.employees.push(element);
                console.log("this.employees_EMPLOYEES", this.employees);
              });
              window.dispatchEvent(new Event("resize"));
              this.renderer.removeClass(document.body, "sidebar-enable");
              this.renderer.addClass(document.body, "vertical-collpsed");
              this.employees.filter((data) => {
                return data.status == 1;
              });
              return;
            },
            (error) => {
              this.store.dispatch(setLoadingSpinner({ status: false }));
              this.isEmpty = true;
            }
          );

        return this.dataSubscription;
      },
      drawCallback: () => {
        const dataTable = $('#employees-table').DataTable();
        $('.dataTables_empty').hide();  // Hide "No matching records found" if necessary

        // Update pagination info
        const pageInfo = dataTable.page.info();
        const totalRecords = pageInfo.recordsTotal;
        const start = pageInfo.start + 1;
        let end = pageInfo.start + pageInfo.length;
        if (totalRecords < pageInfo.length) {
          end = pageInfo.length; // If fewer records than per page limit, extend end to full page size
        } else {
          end = Math.min(end, totalRecords); // Adjust end if it exceeds the total records otherwise
        }

        // Adjust the displaying end to the maximum if the total records number is less than page size
        const displayEnd = pageInfo.recordsDisplay < pageInfo.length ? pageInfo.length : Math.min(pageInfo.length, pageInfo.recordsDisplay);

        const customPaginationText = `Showing ${start} to ${displayEnd} of ${totalRecords} entries`;

        // Translate and update the pagination info text
        this.translatePipe.transform(customPaginationText).subscribe(translatedText => {
          $('.dataTables_info').text(translatedText);
        });

        // Update DataTable Length Label and Buttons
        let $dataTablesLengthLabel = $('.dataTables_length label');
        let textNode = $dataTablesLengthLabel.contents().filter(function () {
          return this.nodeType === Node.TEXT_NODE;
        });
        if (textNode.length > 0 && textNode.length === 2) {
          forkJoin([
            this.translatePipe.transform('Show'),
            this.translatePipe.transform('entries'),
            this.translatePipe.transform('Previous'),
            this.translatePipe.transform('Next')
          ]).subscribe(([showTranslation, entriesTranslation, prevText, nextText]) => {
            textNode[0].nodeValue = showTranslation;
            textNode[1].nodeValue = entriesTranslation;

            $('.paginate_button.previous').text(prevText);
            $('.paginate_button.next').text(nextText);
          });
        }

        // Update search placeholder text
        let $searchInput = $('.dataTables_filter label input');
        if ($searchInput.length > 0) {
          this.translatePipe.transform(this.dtOptions.language.searchPlaceholder).subscribe(placeholder => {
            $searchInput.attr('placeholder', placeholder);
          });
        }
      }
    };


    this.translatePipe.transform(this.dtOptions.language.searchPlaceholder)
      .subscribe(res => {
        this.dtOptions.language.searchPlaceholder = res;
      });


    this.dropdownSettings = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      // day: "day",
      // startTime: "startTime",
      // endTime: "endTime",
      // recurring: "recurring",
      // nextDay: "nextDay",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 2,
      allowSearchFilter: "ShowFilter",
    };
  }

  getCustomDate(inputDate, customHour, customMinutes) {
    // Create a new Date object based on the input date
    var date = new Date(inputDate);

    // Set the custom hour and minutes to the date
    date.setHours(customHour);
    date.setMinutes(customMinutes);

    // Get Unix timestamp (in seconds) by dividing milliseconds by 1000
    var timestampInSeconds = Math.floor(date.getTime() / 1000);

    return timestampInSeconds;
  }

  unixToDate(date) {
    return this.timezoneService
      .get()(date * 1000)
      .format("MM-DD-YYYY");
  }

  //to be removed
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  dropdownSettings2 = {}
  sampletr: boolean = false;
  timezone;
  selectedDate(value: any) {
    // this.showItemCountPP = 0;
    // this.p = 1;
    this.startDate = value.start;
    this.endDate = value.end;
    // console.log("STARTDATEEEEEEEEE", this.startDate)
    // console.log("ENDDDATEEEEEEEEE", this.endDate)
    this.startDateDisplay = this.startDate.unix();
    this.endDateDisplay = this.endDate.unix();
    // console.log("STARTDISPLAYYYYYYYY", this.startDateDisplay)
    // console.log("ENDDDISPLAYYYYYYYY", this.endDateDisplay)
    this.startDateDisplayFormatted = this.timezoneService
      .get()
      .unix(this.startDateDisplay)
      .format("MMM Do YYYY");
    this.endDateDisplayFormatted = this.timezoneService
      .get()
      .unix(this.endDateDisplay)
      .format("MMM Do YYYY");
    //  this.refreshDataTable3();
    this.getSupportTicketsForSelectedDates();
  }
  refreshDataTable3() {
    this.store.dispatch(setLoadingSpinner({ status: true }));
    console.log("objectrefreshDataTable :>> ", this.datatableElement)
    if (this.datatableElement) {
      this.datatableElement?.dtInstance.then((dtInstance: DataTables.Api) => {
        // Reload the table data from the Ajax data source
        dtInstance.ajax.reload((json) => {
          console.log("dtinstance_FROM_AJAX", dtInstance.data(), dtInstance.page.info(), json);
          // If the response data is empty, go to the first page
          // this.activityLog = json.response;
          if (json.response.length === 0 && dtInstance.page.info().page > 0) {
            console.log("Data table refreshed and going to first page")
            dtInstance.page('first').draw('page');
          }
        }, false); // Pass false to keep the current paging position
        console.log("Data table refreshed");
      });
    }
  }
  getSupportTicketsForSelectedDates(offset = 0, limit = 10) {
    this.store.dispatch(setLoadingSpinner({ status: true }));

    const params = new HttpParams()
      // .set('storeId', this.storeId)
      .set('offset', offset.toString())
      // .set('limit', limit.toString())
      // .set('merchantId', this.merchantId)
      .set('startDate', this.startDateDisplay)
      .set('endDate', this.endDateDisplay)
      .set('status', '1');

    this.http.get<{ success: number, response: any, total: number, closeIssue: number, openIssue: number }>(`${this.GLOBALURL}/merchants/issues`, { params })
      .subscribe({
        next: data => {
          this.store.dispatch(setLoadingSpinner({ status: false }));
          if (data.success === 1) {
            console.log("DATAAAAAAAAAAAAA", data)
            this.totalCount = data.total;
            this.employees = data.response;
            this.totalComplate = data.closeIssue;
            this.totalPending = data.openIssue;
            this.cdr.detectChanges();
          } else {
            this.toastr.error('Failed to load data');
          }
        },
        error: error => {
          this.toastr.error('An error occurred');
          this.store.dispatch(setLoadingSpinner({ status: false }));
        }
      });
  }
  createTranslateArr(arr: any) {
    let newArr = [];
    arr.forEach((item) => {
      if (item && typeof item.textContent === 'string') {
        newArr.push(this.translatePipe.transform(item.textContent));
      }
    });
    return newArr;
  }
  translateArrayOfTexts($arrToTranslate: string[], arrOfElements: any) {
    if ($arrToTranslate.length === 0) return;

    forkJoin($arrToTranslate)
      .subscribe(texts => {
        texts.forEach((text, i) => {
          arrOfElements[i].textContent = text;
        });
      },
        (error) => {
          console.error("Error in translating:", error);
        })
  }
  setDateTexts() {
    setTimeout(() => {
      let ranges = document.querySelectorAll(".ranges li");
      let $ranges = this.createTranslateArr(ranges);

      let months = document.querySelectorAll(".table-condensed .month");
      let $months = this.createTranslateArr(months);

      let buttons = document.querySelectorAll(".drp-buttons .btn");
      let $buttons = this.createTranslateArr(buttons);

      // this.translateArrayOfTexts($first, first);
      this.translateArrayOfTexts($buttons, buttons);
      this.translateArrayOfTexts($ranges, ranges);
      this.translateArrayOfTexts($months, months)

    }, 1);

  }
  // getStoreSupportTicketsForSelectedDates() {
  //   throw new Error("Method not implemented.");
  // }

  async ngOnInit() {
    this.store.dispatch(setLoadingSpinner({ status: true }));
    this.editorConfig = {
      ...this.editorConfig,
      isReadOnly: true
    };


    this.BreadcrumbService.setValue(this.breadcrumbItems);

    if (!Boolean(this.currency)) {
      this.currency = "$";
    }

    this.AppAliasService.getStoreValue().subscribe((res) => {
      if (res === '*') {
        this.toastr.error('Please select a store');
        return;
      }
    }
    );
    // this.store.dispatch(setLoadingSpinner({ status: true }));
    const geticon = this.el.nativeElement.querySelector('.fc-icon fc-icon-chevron-left');

    if (geticon) {
      this.renderer.removeClass(geticon, 'fc-icon fc-icon-chevron-left');
      this.renderer.addClass(geticon, 'fa-solid fa-less-than');
    }

    this.modalConfig.backdrop = "static";
    this.modalConfig.keyboard = false;

  }


  startTimeFormatted: any = "";
  endTimeFormatted: any = "";
  dateTimeArray: any[] = [];
  ClosingDay = "Same Day";

  objectToHttpParams(obj: any) {
    return Object.entries(obj || {}).reduce((params, [key, value]) => {
      return params.set(
        key,
        _.isObjectLike(value) ? JSON.stringify(value) : String(value)
      );
    }, new HttpParams());
  }

  reload() {
    // save current route first
    const currentRoute = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "reload";
    this.router.navigate([currentRoute]);
  }

  // date: any
  // day: any
  // month: any
  // year: any
  today: any;

  startDateWithTime: any;
  endDateWithTime: any;

  refreshDataTable() {
    if (this.datatableElement) {
      this.datatableElement?.dtInstance.then((dtInstance: DataTables.Api) => {
        // Reload the table data from the Ajax data source
        dtInstance.ajax.reload((json) => {
          console.log("dtinstance_FROM_AJAX", dtInstance.data(), dtInstance.page.info(), json);
          // If the response data is empty, go to the first page
          if (json.response.length === 0 && dtInstance.page.info().page > 0) {
            console.log("Data table refreshed and going to first page")
            dtInstance.page('first').draw('page');
          }
        }, false); // Pass false to keep the current paging position
        console.log("Data table refreshed");
      });
    }
  }

  // onChange(event: ChangeEvent): void {
  //   console.log("onCange", event.editor?.getData());
  //   this.componentEvents.push('Editor model changed.');
  // }

  // onFocus(event: FocusEvent): void {
  //   this.componentEvents.push('Focused the editing view.');
  // }

  // onBlur(event: BlurEvent): void {
  //   this.componentEvents.push('Blurred the editing view.');
  // }
  // onReady(editor) {
  //   editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
  //     console.log("OnReady_LOADER", loader);
  //     console.log("OnReady_EDITOR", editor);
  //     return new Adapter(loader, editor.config);;
  //   };

  // }


  employeeDetails: any = {};
  employeeServerId: any;
  employeeOrderHistory: any = [];
  loaderState = false;

  _convertDateKeys = {};
  _convertDate = (id: string, date: any) => {
    if (!this._convertDateKeys[id]) {
      if (date) {
        this._convertDateKeys[id] = this.timezoneService
          .get()(date * 1000)
          .format("MMM DD, YYYY");
      } else {
        return "";
      }
    }
    return this._convertDateKeys[id];
  };

  _convertTimeKeys = {};
  _convertTime = (id: string, date: any) => {
    if (!this._convertTimeKeys[id]) {
      if (date) {
        this._convertTimeKeys[id] = this.timezoneService
          .get()
          .unix(date)
          .format("h:mm A");
      } else {
        return "";
      }
    }
    return this._convertTimeKeys[id];
  };

  __convertTime = (id: string, date: any) => {
    if (!this._convertTimeKeys[id]) {
      if (date) {
        this._convertTimeKeys[id] = this.timezoneService
          .get()
          .unix(date)
          .format("h:mm A");
      } else {
        return "";
      }
    }
    return this._convertTimeKeys[id];
  };

  /**
   * Event click modal show
   */
  handleEventClick(clickInfo: EventClickArg) {
    console.log("CLICK INFO----", clickInfo.event.title);
  }



  /**
   * Events bind in calander
   * @param events events
   */
  handleEvents(events: EventApi[]) {
    // this.currentEvents = events;
  }

  // to be removed
  open(content) {
    this.modalService.open(content);
  }
  onItemSelect(item: any) {
    console.log(item);
  }
  onSelectAll(items: any) {
    console.log(items);
  }
  //end to be removed

  totalEmployees: any = 0;
  employees = [];
  scheduleEmployees = [];
  employeesCopy: any = [];
  orderByName: boolean = false;
  httpOptions3: any = {};

  formatHHMMTime(time, type) {
    let hour = Math.floor(time / 3600);
    let minute = Math.floor((time % 3600) / 60);

    if (!time) {
      return "0h 0m";
    }

    if (type == 2) {
      return `${hour}hrs ${minute}mins`;
    } else {
      return `${hour}h ${minute}m`;
    }
  }

  convertUnixTime(time) {
    return this.timezoneService
      .get()(new Date(time * 1000))
      .format("h:mm A");
  }

  formatTime(time) {
    if (!time) {
      return "";
    }

    return this.timezoneService.get()(time, "hh:mm A").format("HH:mm");
  }

  hasStartNullDateError = "";
  hasEndNullDateError = "";
  // hasBothDateNullError = "";
  hasJobTypeNullError = "";
  startTimeLessError = "";
  overLapError = "";
  payloadObjectArr = [];
  newPayloadDaysObj: any;

  formatTimeStartEnd = (): any => {
    const Timezone = this.timezoneService.get()

    let obj = {
      ...this.addShiftForm.value,
    };

    const SD = Timezone(this.addShiftForm.value.startDate * 1000).format('YYYY-MM-DD')
    const ED = Timezone(this.addShiftForm.value.endDate * 1000).format('YYYY-MM-DD')

    obj["startDate"] = parseInt(Timezone(SD + " " + this.startTime).format("X"))
    obj["endDate"] = parseInt(Timezone(ED + " " + this.endTime).format("X"))

    return obj;
  }

  changeStore(event: any) {
    this.params = new HttpParams();
    this.storeId = event;
    this.store.dispatch(setLoadingSpinner({ status: true }));
    if (event !== "*") {
      this.params = this.params.set("storeId", this.storeId);
      this.httpOptions = {
        headers: new HttpHeaders(this.headerToken),
        params: this.params,
      };

      this.refreshDataTable();
    } else {
      this.httpOptions = { headers: new HttpHeaders(this.headerToken) };

      this.refreshDataTable();
    }
  }

  goToAddPage() {
    if (this.storeId == "*" || this.storeId == undefined) {
      this.toastr.error("Please select a location first.");
      return;
    }

    this.router.navigate(["/support-tickets-merchant/add"]);
  }

  ngOnDestroy() {
    if (this.dataSubscription) this.dataSubscription.unsubscribe();
  }

  convertDate(timeStamp: number) {
    if (timeStamp) {
      return this.timezoneService
        .get()(timeStamp * 1000)
        .format("D-MMM-YYY");
    } else {
      return "";
    }
  }

  convertTime(timeStamp: number) {
    if (timeStamp) {
      return this.timezoneService.get().unix(timeStamp).format("h:mm A");
    } else {
      return "";
    }
  }

  RemoveUnwantedClass() {
    this.renderer.removeClass(document.body, "modal-open");
  }

  updateTicket(id: string) {
    if (this.storeId === "*") {
      this.toastr.clear();
      this.toastr.error("Please select a location first.");
      return;
    }

    this.router.navigate(["./update", id], { relativeTo: this.route });
  }

}